import React, { useEffect, useState } from "react";
import { string, number, array } from "prop-types";
import axios from "axios";

import ResizeContext from "./../Contexts/ResizeContext";
import { FilterBar } from "../Components/FilterBar";
import { Navigation } from "./../Components/Navigation";
import SellerCard from "./../Components/SellerCard";

const SearchCriteria = ({
    path,
    listKey,
    initialPage,
    initialPageSize,
    initialFilter,
    initialSort
}) => {
    const [page, setPage] = useState(initialPage ? initialPage : 1);
    const [pageSize, setPageSize] = useState(
        initialPageSize ? initialPageSize : 24
    );
    const [maxPage, setMaxPage] = useState(1);
    const [filter, setFilter] = useState(initialFilter ? initialFilter : []);
    const [sort, setSort] = useState(initialSort ? initialSort : []);
    const [data, setData] = useState({});

    useEffect(() => {
        axios
            .get(`/api/${path}`, {
                params: {
                    currentPage: page,
                    pageSize,
                    filterGroups: JSON.stringify(filter),
                    sortOrders: JSON.stringify(sort)
                }
            })
            .then(({ data }) => {
                setData(data);
                setMaxPage(Math.ceil(data.total / pageSize));
            })
            .catch(err => {
                console.error(err);
            });
    }, [filter, page, pageSize, path, setData, sort]);

    return (
        <ResizeContext.Provider
            value={{
                isMobile: false
            }}>
            <div className="container-fluid p-0 SearchCriteria">
                <div className="row">
                    <div className="col-12 col-sm-5 col-lg-3 sidebarFilters">
                        <FilterBar
                            title="Refine by..."
                            optionGroups={[
                                {
                                    title: "Category",
                                    options: [
                                        { name: "Laboratory",
                                            value: "49" }
                                    ]
                                }
                            ]}
                        />
                    </div>
                    <div className="col-12 col-lg-9 col-md-12">
                        <h2 className="title h1-clone">
                            Showing {page * pageSize - (pageSize - 1)} -{" "}
                            {page * pageSize} of {data.total} Items
                        </h2>
                        <div className="catalog">
                            <Navigation
                                currentPage={page}
                                maxPage={maxPage}
                                pageSize={pageSize}
                                pageSizeOptions={["24", "32", "64", "96"]}
                                goTo={newPage => setPage(newPage)}
                                changePageSize={newPageSize =>
                                    setPageSize(newPageSize)
                                }
                                changeSortBy={newSort => setSort(newSort)}
                            />
                            <div className="product-list">
                                {data &&
                                    data[listKey] &&
                                    Array.isArray(data[listKey]) &&
                                    data[listKey].map(item => {
                                        return (
                                            <SellerCard
                                                key={item.entity_id}
                                                title={item.shop_title}
                                                image={`${localStorage.getItem(
                                                    "restUrl"
                                                )}/pub/media/avatar/${
                                                    item.logo_pic
                                                }`}
                                                link={`/sellers/profile/${
                                                    item.shop_url
                                                }/${item.seller_id}`}
                                                description={
                                                    item.company_description
                                                }
                                            />
                                        );
                                    })}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </ResizeContext.Provider>
    );
};

SearchCriteria.defaultProps = {
    listKey: "sellers",
    initialFilter: [
        {
            field: "shop_title",
            value: "",
            condition: "notnull"
        },
        {
            field: "is_seller",
            value: "1"
        }
    ],
    initialSort: [
        {
            field: "shop_title",
            direction: "ASC"
        }
    ]
};

SearchCriteria.propTypes = {
    path: string,
    listKey: string,
    initialPage: number,
    initialPageSize: number,
    initialFilter: array,
    initialSort: array
};

export default SearchCriteria;
